
import { PlanMgtActions, PlanMgtActionTypes } from '../actions/plan-mgt.actions';
import {PlanMgt} from '../plan.model';

export interface State {
  Loaded: boolean;
  Loading: boolean;
  entities: PlanMgt[];
}

export const initialState: State = {
  Loaded: false,
  Loading: false,
  entities: []
};

export function reducer(state = initialState, action: PlanMgtActions): State {
  switch (action.type) {
    case PlanMgtActionTypes.GetPlanMgts:
      return {...state, Loaded: false, Loading: true};

    case PlanMgtActionTypes.LoadPlanMgts:
      return {...state, Loaded: true, Loading: false, entities: action.payload};

    case PlanMgtActionTypes.GetPlanMgtsFail:
      return {...state, Loaded: true, Loading: false};

    case PlanMgtActionTypes.GetUpdatePlanMgts:
      return {...state, Loaded: false, Loading: true};

    default:
      return state;
  }
}
